module.exports = __webpack_public_path__ + "static/media/waves-example.f6b14e1e.gif";